import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Onboarding from '@/features/onboarding/Onboarding';
import usePreventDataLoss from '@/hooks/usePreventDataLoss';
import PageLayout from '@/layout/PageLayout';
import { DEFAULT_ROUTE } from '@/routes/Router';
import { useUserStore } from '@/stores/userStore';

const SignupPage = () => {
    const { account } = useUserStore();
    const navigate = useNavigate();
    usePreventDataLoss();

    useEffect(() => {
        if (account?.isOnboarded) {
            navigate(DEFAULT_ROUTE);
        }
    }, []);

    return (
        <PageLayout>
            <Onboarding />
        </PageLayout>
    );
};

export default SignupPage;
